// Types
import type { FilterDataProps } from '@/types/utils/filter-data'

const FilterData = (data: FilterDataProps) => {
	return Object.fromEntries(Object.entries(data).filter(([, value]) => value !== 'undefined' && value !== undefined))
}

export default FilterData
